/**
 * Created by dziamid on 11.5.17.
 */
export const ADD_ENTITIES = 'app/models/ADD_ENTITIES';
export const CLEAR_ENTITIES = 'app/models/CLEAR_ENTITIES';
export const CLEAR_ENTITIES_BY_ID = 'app/models/CLEAR_ENTITIES_BY_ID';
export const CLEAR_SINGLE_ENTITY = 'app/models/CLEAR_SINGLE_ENTITY';
export const UPDATE_ENTITIES = 'app/models/UPDATE_ENTITIES';
